import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as Scroll from 'react-scroll';

import { Forms, Modal, SaveButton, SystemText } from '@salesperformanceint/e4shared';

import { updateComment } from 'actions/blog';
import { setSaving } from 'actions/ui';

export const ManageComment = ({ commentProps, show, close, post, reload }) => {
    const [comment, setComment] = useState('');
    const [errors, setErrors] = useState({});

    const saving = useSelector(state => state.ui.saving);
    const tags = useSelector(state => state.ui.tags);
    const handles = useSelector(state => state.ui.handles);

    const dispatch = useDispatch();

    useEffect(() => {
        if (commentProps?.comment) {
            setComment(commentProps.comment);
        }
    }, [commentProps]);

    const validate = comment => {
        let result = true;
        const errors = {};

        if (comment.comment.length === 0) {
            errors.title = SystemText('BlogPost/ManageComment/Form/TitleError');
            result = false;
        }

        setErrors({ errors });

        if (!result) document.getElementsByClassName('modal')[0].scrollTop = 0;

        return result;
    };

    const save = () => {
        const commentToSave = {
            ...commentProps,
            comment: comment,
            post_Id: post.id,
        };

        if (validate(commentToSave)) {
            dispatch(updateComment(commentToSave, () => closeModal()));
            setComment('');
        } else {
            dispatch(setSaving(false));
        }
    };

    const closeModal = () => {
        reload?.();
        close?.();
    };

    const footer = (
        <div>
            <SaveButton
                saving={saving}
                setSaving={() => dispatch(setSaving)}
                className="btn btn-success"
                onClick={() => save()}
            >
                {SystemText('BlogPost/ManageComment/Buttons/Save')}
            </SaveButton>
            <button className="btn" onClick={() => close()}>
                {SystemText('BlogPost/ManageComment/Buttons/Cancel')}
            </button>
        </div>
    );

    const editCommentString = SystemText('BlogPost/ManageComment/EditComment');
    const addNewCommentString = SystemText('BlogPost/ManageComment/AddNewComment');

    const title = commentProps ? editCommentString : addNewCommentString;

    return (
        <Modal show={show} title={title} close={close} footer={footer}>
            <Scroll.Element name="top-of-modal" />
            <div className="form-group" id="manage-task-form">
                <Forms.Textarea
                    tags={tags}
                    handles={handles}
                    value={comment}
                    placeholder={SystemText('BlogPost/ManageComment/Fields/Title/Placeholder')}
                    onChange={value => setComment(value)}
                    label={SystemText('BlogPost/ManageComment/Fields/Title/Label')}
                    rows="10"
                />
            </div>
        </Modal>
    );
};

export default ManageComment;
